/* eslint-disable react/prop-types */
import React from 'react'
import { useOutletContext } from 'react-router-dom'
import RoutedMenu from '../../../../RoutedMenu/RoutedMenu'

export function SellerTab() {
    const {
        canUpdateSellerContent, subTab,
    } = useOutletContext()

    return (
        <div style={{ margin: '30px 0 0 0' }}>
            <RoutedMenu
                activeTab={subTab}
                items={[
                    { label: 'Customize Page', to: 'customize-page' },
                    { label: 'Marketing Assets', to: 'marketing-assets' },
                ]}
                context={{
                    canUpdate: canUpdateSellerContent,
                }}
            />
        </div>
    )
}

export default SellerTab
